import axios from 'axios';

const BEARER_VAL = 'MOBILE_TEST_AUTH';
const EC2_PATH = 'http://54.91.185.110';
const BASE_PATH =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:4004'
    : process.env.REACT_APP_ENV === 'stage-qbank'
    ? 'https://hippostage-api-qbank.silverorange.com'
    : process.env.REACT_APP_ENV === 'roble'
    ? 'https://hippostage-api.silverorange.com'
    : 'https://api.hippoed.com';

export const REDIRECT_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:4004/sign-in?callback=http://localhost:3000'
    : process.env.REACT_APP_ENV === 'stage-qbank'
    ? 'https://hippostage.silverorange.com/hippo-ed/work-qbank/dist/signin?callback=https://hippostage.silverorange.com'
    : process.env.REACT_APP_ENV === 'roble'
    ? 'https://hippostage.silverorange.com/hippo-ed/work-hive/dist/signin?callback=https://hippostage.silverorange.com'
    : 'https://www.hippoed.com/signin?callback=https://qbank.hippoed.com';
export const ASSET_PREFIX = {
  '2dbff6f7-3fb9-4f37-9ae8-d911168384c2': 'EM',
  '9814f474-05b4-4b07-9a39-489433431e92': 'peds',
  'a735b689-e6d0-419b-b785-76fe33f86f3d': 'pa'
};

const JSON_API_PATH = process.env.REACT_APP_EC2
  ? `${EC2_PATH}:4004`
  : BASE_PATH;
// TODO REMOVE HEADERS ONCE AUTH IS UP
export const ACTIONS = {
  TYPES: {
    APP: {
      INIT_SUCCESS: 'APP_INIT_SUCCESS',
      CHANGE_STATE: 'APP_CHANGE_STATE',
      UPDATE_APP: 'UPDATE_APP',
      FETCH_STATS_SUCCESS: 'FETCH_STATS_SUCCESS',
      FETCH_FILTERED_SUCCESS: 'FETCH_FILTERED_SUCCESS'
    },
    AUTH: {
      UPDATE_AUTH: 'UPDATE_AUTH'
    },
    QUESTION: {
      GET_INITIALIZED: 'QUESTION_GET_INITIALIZED',
      GET_SUCCESS: 'QUESTION_GET_SUCCESS',
      GET_ERROR: 'QUESTION_GET_ERROR',
      OPTION_SELECTED: 'QUESTION_OPTION_SELECTED',
      QUESTION_SELECTED: 'QUESTION_SELECTED',
      QUESTION_ANSWERED: 'QUESTION_ANSWERED',
      GET_OPTION_STATS: 'GET_OPTION_STATS',
      GET_OPTION_STATS_SUCCESS: 'GET_OPTION_STATS_SUCCESS'
    },
    QUIZ: {
      INITIALIZE_SUCCESS: 'QUIZ_INITIALIZE_SUCCESS',
      INITIALIZE_ERROR: 'QUIZ_INITIALIZE_ERROR',
      UPDATE_QUIZ: 'UPDATE_QUIZ'
    },
    EXAMTAG: {
      GET_INITIALIZED: 'EXAMTAG_GET_INITIALIZED',
      GET_SUCCESS: 'EXAMTAG_GET_SUCCESS',
      GET_ERROR: 'EXAMTAG_GET_ERROR',
      UPDATE: 'EXAMTAG_UPDATE'
    },
    TAG: {
      GET_INITIALIZED: 'TAG_GET_INITIALIZED',
      GET_SUCCESS: 'TAG_GET_SUCCESS',
      GET_ERROR: 'TAG_GET_ERROR',
      UPDATE: 'TAG_UPDATE'
    },
    SIGNIN: {
      SIGNIN_INITIALIZED: 'SIGNIN_INITIALIZED',
      SIGNIN_SUCCESS: 'SIGNIN_SUCCESS',
      SIGNOUT_SUCCESS: 'SIGNOUT_SUCCESS'
    },
    QUESTION_STATS: {
      GET_INITIALIZED: 'STATS_GET_INITIALIZED',
      GET_SUCCESS: 'STATS_GET_SUCCESS',
      UPDATE_ATTRIBUTE_INITIALIZED: 'UPDATE_ATTRIBUTE_INITIALIZED',
      UPDATE_ATTRIBUTE_SUCCESS: 'UPDATE_ATTRIBUTE_SUCCESS'
    },
    TOOLBOX: {
      NOTES_EDIT: 'NOTES_EDIT'
    }
  },
  HEADERS: {
    Authorization: `Bearer ${BEARER_VAL}`
  },
  AXIOS: expiresAt => {
    return expiresAt && expiresAt < new Date().getTime()
      ? (window.location = REDIRECT_URL)
      : axios;
  },
  JSON_API_PATH: process.env.REACT_APP_MOBILE_TEST
    ? 'http://10.0.0.49:4004'
    : JSON_API_PATH
};

export const CONSTANTS = {
  MODE: {
    PRACTICE: 0,
    TEST: 1
  },
  PRODUCT_ID: {
    em: {
      id: '2dbff6f7-3fb9-4f37-9ae8-d911168384c2',
      shortname: 'hippo-em'
    },
    peds: {
      id: '9814f474-05b4-4b07-9a39-489433431e92',
      shortname: 'hippo-peds'
    },
    pa: {
      id: 'a735b689-e6d0-419b-b785-76fe33f86f3d',
      shortname: 'hippo-pa'
    }
  },
  SETTINGS_KEYS: {
    RETIRE_AFTER_COUNT: 'retireAfterCount',
    SHOW_CORRECT_AFTER: 'showCorrectAfter',
    SHOW_INCORRECT_AFTER: 'showIncorrectAfter'
  },
  FIRST_RUN_FIELDS: {
    EXAM_TYPE: 'examType',
    EXAM_DATE: 'examHappensAt',
    TRAINING_LEVEL: 'ProfessionId',
    SPECIALTY: 'specialty'
  },
  EXAM_TYPES: {
    EM: {
      IN_TRAINING: 'In-training Exam',
      QUALIFYING: 'Qualifying Exam',
      CONCERT: 'ConCert Exam',
      OTHER: 'Other',
      NA: 'Not taking a test'
    },
    PEDS: {
      IN_TRAINING: 'In-training Exam',
      CERTIFYING: 'Certifying Exam',
      RECERTIFICATION: 'Recertification Exam',
      CAQ: 'Pediatrics CAQ',
      NBME: 'NBME Shelf Exam',
      NA: 'Not prepping for an exam'
    },
    PA: {
      PANCE: 'PANCE',
      PANRE: 'PANRE',
      PANRE2: 'PANRE Alternative',
      NA: 'Not studying for exam'
    }
  },
  SPECIALTIES: {
    EM: 'Emergency Medicine',
    FM: 'Family Medicine',
    IM: 'Internal Medicine',
    PEM: 'Peds Emergency Medicine',
    PED: 'Pediatrics',
    OTHER: 'Other'
  }
};

export const NAVSTATES = {
  init: true,
  dashboard: true,
  flagged: true,
  quiz: true,
  settings: true
};

export const HELPERS = {
  UPDATE_OBJECT: (updateObject, questionIndex, optionIndex) => ({
    updateObject,
    questionIndex,
    optionIndex
  }),
  GET_PERCENT_COLOR: p => (p < 71 ? '#FF7065' : p < 86 ? '#DFDF56' : '#95BF5E')
};



// WEBPACK FOOTER //
// ./src/config/constants.js